import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {
  CreateUpdateDefaultPagePageModule
} from "../../../../../../core/page/create-update-default-page/create-update-default-page.module";
import {
  MultipleSelectFilterModule
} from "../../../../../../core/component/multiple-select-filter/multiple-select-filter.module";
import {SelectFilterModule} from "../../../../../../../components/common/select-filter/select-filter.module";
import {UserAvatarModule} from "../user-avatar/user-avatar.module";
import {UntypedFormGroup} from "@angular/forms";
import {UserSummary} from "../../entity/userSummary.model";
import {BehaviorSubject} from "rxjs";
import {SelectFilterElement} from "../../../../../../../components/common/select-filter/select-filter.model";
import {UserPaginatedService} from "../../service/userPaginated.service";

@Component({
  selector: 'app-user-select-filter-standalone',
  templateUrl: './user-select-filter-standalone.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MultipleSelectFilterModule,
    SelectFilterModule,
    UserAvatarModule,
  ]
})
export class UserSelectFilterStandaloneComponent implements AfterViewInit, OnChanges {

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() multiple = false;
  @Input() users: UserSummary[] = [];
  @Input() loading = false;

  @Output() userSelectedEvent: EventEmitter<UserSummary> = new EventEmitter<UserSummary>();

  usersElements: BehaviorSubject<SelectFilterElement<number, UserSummary>[]> = new BehaviorSubject<SelectFilterElement<number, UserSummary>[]>([]);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['users'] && this.users) {
      this.usersElements.next(this.users
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(value => new SelectFilterElement(value.id, value.id, value)));
    }
  }

  ngAfterViewInit() {
  }


  filter = (criteria: string, user: UserSummary) => {
    return (user.name).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
  }
}
